 import { io } from "socket.io-client";

let socket = null;

export const connectSocket = (token) => {
  if (socket) return socket;

  socket = io("https://borrowhub-backend.onrender.com", {
    auth: { token },
    transports: ["websocket"],
  });

  socket.on("connect", () => {
    console.log("🟢 SOCKET CONNECTED:", socket.id);
  });

  socket.on("disconnect", () => {
    console.log("🔴 SOCKET DISCONNECTED");
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
